import { WidgetError } from "./widget-error.js";

/**
 * @class
 * @classdesc Invalid or Expired Access Token
 * @augments WidgetError
 */
export class InvalidAccessToken extends WidgetError {

    /**
     * @param {string} cause Root cause of the error
     * @param {object} rawError Error coming from Davinci
     * @constructor
     */
    constructor(cause, rawError = {}) {
        super("InvalidAccessToken", cause, rawError);
    }
}